import React, { FC, PropsWithChildren } from 'react'
import styles from './styles.module.scss'
import { CSSUtils } from "@buderus-apps/components";

type TProps = PropsWithChildren<{
  isNewChat: boolean
}>
const Body: FC<TProps> = (props) => {
  const { children, isNewChat } = props

  return (
    <div className={CSSUtils.classnames(styles.body, {
      [styles['body--new-chat']]: isNewChat
    })}>
      {children}
    </div>
  )
}

export default React.memo(Body)
